import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, OccProductCondition, OccProductConditionModel } from '@product/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccProductConditionService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadConditions(productCode: string): Observable<OccProductCondition[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.condition, {
      urlParams: {
        productCode,
      },
    });

    return this.http
      .get<OccProductConditionModel>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.condition),
      })
      .pipe(map((response) => response.conditions));
  }
}
